import type { RouteRecordRaw } from 'vue-router';

// Redirect legacy /bid route to the BidSheet overlay via ?bid= query param.
// The shell-level BidSheet is the canonical bid UI; PlaceBidPage is retired.
export const routes: RouteRecordRaw[] = [
  {
    // Legacy path — kept so the magic-link "next" URL still works.
    // Redirects to the item detail with ?bid=1, which opens the bottom
    // sheet mounted inside ItemDetailPage.
    path: '/:slug/items/:id/bid',
    name: 'place-bid',
    redirect: (to) => ({
      path: `/${to.params.slug as string}/items/${to.params.id as string}`,
      query: {
        ...to.query,
        bid: to.params.id as string,
      },
    }),
  },
];
